import { Injectable } from "@angular/core";
import { AppMenuItem } from "./app-menu-item";
import { AppMenu } from "./app-menu";
import { PermissionCheckerService } from "@abp/auth/permission-checker.service";

@Injectable()
export class AppNavigationService {
    constructor(private _permissionService: PermissionCheckerService) {}

    getMenu(): AppMenu {
        return new AppMenu("MainMenu", "MainMenu", [
            new AppMenuItem(
                "TenantStoreGroup",
                "Pages.Franshieses",
                //"",
                "la la-sitemap",
                "/app/admin/StoreGroupsDashboard",
                [],
                true,
            ),
            new AppMenuItem(
                "Dashboard",
                "Pages.Administration.Host.Dashboard",
                "la la-tachometer",
                "/app/admin/hostDashboard",
            ),
            new AppMenuItem(
                "MangementDashboard",
                "Pages.Administration.Management.Dashboard",
                "la la-area-chart",
                "/app/admin/mangementDashboard",
            ),

            new AppMenuItem(
                "Dashboard",
                "Pages.Tenant.Dashboard",
                "la la-tachometer",
                "/app/main/dashboard",
            ),
            new AppMenuItem(
                "Reports",
                "Pages.ReportsFB",
                "la la-bar-chart",
                "",
                [
                    new AppMenuItem(
                        "ReportOfSales",
                        "Pages.FBReports.ReportsSalesFAB",
                        "la la-line-chart",
                        "",
                        [
                            new AppMenuItem(
                                "SupplySet",
                                "Pages.ReportsFB.Balance",
                                "la la-money",
                                "/app/reports/balancereportfb",
                            ),
                            new AppMenuItem(
                                "TotalSalesByTime",
                                "Pages.ReportsFB.TotalSalesByTimeFB",
                                "la la-clock-o",
                                "/app/reports/totalSalesByTime",
                            ),
                            new AppMenuItem(
                                "SalesReport",
                                "Pages.ReportsFB.SalesFB",
                                "la la-shopping-cart",
                                "/app/reports/salesfbreport",
                            ),
                            new AppMenuItem(
                                "SalesSummaryReport",
                                "Pages.ReportsFB.SalesSummary",
                                "la la-pie-chart",
                                "/app/reports/SalesSummaryFb",
                            ),
                            new AppMenuItem(
                                "AllSaleTransactionDetails",
                                "Pages.ReportsFB.AllSaleTransactionDetails",
                                "la la-list-ul",
                                "/app/reports/AllSaleTransactionDetails",
                            ),
                            new AppMenuItem(
                                "StoresDayTotalSales",
                                "Pages.ReportsFB.StoresDayTotalSales",
                                "la la-building-o",
                                "/app/reports/StoresDayTotalSales",
                            ),
                            new AppMenuItem(
                                "SystemSalesReport",
                                "Pages.ReportsFB.SystemSalesReport",
                                "la la-pie-chart",
                                "/app/reports/SystemSalesReport",
                            ),
                            new AppMenuItem(
                                "SystemSalesReportDetails",
                                "Pages.ReportsFB.SystemSalesReportDetails",
                                "la la-list-ul",
                                "/app/reports/SystemSalesReportDetails",
                            ),
                            new AppMenuItem(
                                "ReturnSalesReport",
                                "Pages.ReportsFB.ReturnSalesFB",
                                "la la-undo",
                                "/app/reports/salesreturnfbreport",
                            ),
                            new AppMenuItem(
                                "CashFlowReport",
                                "Pages.ReportsFB.CashFlowFB",
                                "la la-exchange",
                                "/app/reports/cashFlowReportFB",
                            ),
                            new AppMenuItem(
                                "CashierShiftsReport",
                                "Pages.ReportsFB.CashFlowFB",
                                "la la-hourglass-half",
                                "/app/reports/cashierShiftsReportFB",
                            ),
                            new AppMenuItem(
                                "CustomersSalesReport",
                                "Pages.ReportsFAB.CustomersSalesFAB",
                                "la la-users",
                                "/app/reports/customerssalesfabreport",
                            ),
                            new AppMenuItem(
                                "CustomersBalanceReport",
                                "Pages.ReportsFAB.CustomersBalanceFAB",
                                "la la-star-o",
                                "/app/reports/customersbalancefabreport",
                            ),
                            new AppMenuItem(
                                "TotalSalesReport",
                                "Pages.ReportsFAB.TotalSalesFAB",
                                "la la-calculator",
                                "/app/reports/TotalSalesFABReport",
                            ),
                            new AppMenuItem(
                                "TotalSalesByStoresReport",
                                "Pages.ReportsFAB.TotalSalesByStoresFAB",
                                "la la-building-o",
                                "/app/reports/TotalSalesByStoresFABReport",
                            ),
                            new AppMenuItem(
                                "TenderTypesReport",
                                "Pages.ReportsFAB.TenderTypesFAB",
                                "la la-credit-card",
                                "/app/reports/TenderTypesFABReport",
                            ),
                            new AppMenuItem(
                                "TenderTypesSummaryReport",
                                "Pages.ReportsFAB.TenderTypesSummaryFAB",
                                "la la-credit-card",
                                "/app/reports/TenderTypesFABSummaryReport",
                            ),
                            new AppMenuItem(
                                "IncomeAuditByDay",
                                "Pages.ReportsFAB.IncomeAuditByDay",
                                "la la-calendar-check-o",
                                "/app/reports/IncomeAuditByDay",
                            ),
                            new AppMenuItem(
                                "CashierTotalSalesWithTender",
                                "Pages.ReportsFAB.TenderTypesByCashierFAB",
                                "la la-credit-card",
                                "/app/reports/Cashiertendertypesreport",
                            ),
                            new AppMenuItem(
                                "TenderMediaByTimeReport",
                                "Pages.ReportsFB.TenderTypeMediaByTime",
                                "la la-clock-o",
                                "/app/reports/tenderMediaByTimeReport",
                            ),
                            new AppMenuItem(
                                "ProductSalesReport",
                                "Pages.ReportsFAB.ProductSalesFAB",
                                "la la-cutlery",
                                "/app/reports/ProductSalesFABReport",
                            ),
                            new AppMenuItem(
                                "TotalSalesByModifiers",
                                "Pages.ReportsFAB.TotalSalesByModifiers",
                                "la la-plus-square-o",
                                "/app/reports/TotalSalesByModifiers",
                            ),
                            new AppMenuItem(
                                "ProductSalesWithTobacoTaxFAB",
                                "Pages.ReportsFAB.ProductSalesWithTobacoTaxFAB",
                                "la la-legal",
                                "/app/reports/ProductSalesWithTobaccoTaxFABReport",
                            ),
                            new AppMenuItem(
                                "ProductSalesByTimeReport",
                                "Pages.ReportsFAB.ProductSalesByTimeFAB",
                                "la la-clock-o",
                                "/app/reports/ProductSalesByTimeReport",
                            ),
                            new AppMenuItem(
                                "MenuItemSalesVSCost",
                                "Pages.ReportsFB.MenuItemSalesVSCost",
                                "la la-columns",
                                "/app/reports/MenuItemSalesVSCost",
                            ),
                            new AppMenuItem(
                                "ProductCashierReportFB",
                                "Pages.ReportsFAB.ProductCashierReportFB",
                                "la la-user",
                                "/app/reports/ProductCashierSalesFABReport",
                            ),
                            new AppMenuItem(
                                "ProductCategoriesSalesReport",
                                "Pages.ReportsFAB.ProductCategoriesSalesFAB",
                                "la la-th-large",
                                "/app/reports/productscategoriesalesfabreport",
                            ),
                            new AppMenuItem(
                                "totalSalesCategoriesByCashier",
                                "Pages.ReportsFAB.ProductCategoriesSalesFAB",
                                "la la-user",
                                "/app/reports/totalSalesCategoryByCashierReport",
                            ),
                            new AppMenuItem(
                                "ProductCategoriesByTimeSalesReport",
                                "Pages.ReportsFAB.ProductCategoriesByTimeSalesFAB",
                                "la la-clock-o",
                                "/app/reports/ProductCategoriesByTimeSalesReport",
                            ),
                            new AppMenuItem(
                                "SalesCashierReport",
                                "Pages.ReportsFB.SalesCashiers",
                                "la la-user",
                                "/app/reports/salescashiersreportfb",
                            ),
                            new AppMenuItem(
                                "compareSalesDayByDayReport",
                                "Pages.ReportsFAB.compareSalesDayByDayFAB",
                                "la la-columns",
                                "/app/reports/CompareSalesFABReport",
                            ),
                            new AppMenuItem(
                                "CompareSalesPeriodByPeriodReport",
                                "Pages.ReportsFAB.CompareSalesPeriodByPeriodFAB",
                                "la la-columns",
                                "/app/reports/CompareSalesPeriodByPeriodFABReport",
                            ),
                            new AppMenuItem(
                                "CompareStocksSalesReport",
                                "Pages.ReportsFAB.CompareStocksSalesFAB",
                                "la la-columns",
                                "/app/reports/CompareStockSalesFABReport",
                            ),
                            new AppMenuItem(
                                "MenuItem(Unused)",
                                "Pages.ReportsFB.ProductNotUsed",
                                "la la-ban",
                                "/app/reports/productnotusedreportfb",
                            ),
                            new AppMenuItem(
                                "TrendingMenuItemsReport",
                                "Pages.ReportsFB.TrendingProducts",
                                "la la-fire",
                                "/app/reports/trendingproductsreportfb",
                            ),
                            new AppMenuItem(
                                "EndOfDay",
                                "Pages.ReportsFB.EndOfDay",
                                "la la-moon-o",
                                "/app/reports/endOfDayReportFB",
                            ),
                            new AppMenuItem(
                                "ZatcaTransactions",
                                "Pages.ReportsFB.ZatcaTransactions",
                                "la la-institution",
                                "/app/reports/ZatcaTransactions",
                            ),
                            new AppMenuItem(
                                "ShortOver",
                                "Pages.ReportsFB.ShortOver",
                                "la la-adjust",
                                "/app/reports/ShortOver",
                            ),
                            new AppMenuItem(
                                "Promotion",
                                "Pages.ReportsFB.Promotion",
                                "la la-bullhorn",
                                "/app/reports/Promotion",
                            ),
                            new AppMenuItem(
                                "PromotionByEmployee",
                                "Pages.ReportsFB.PromotionByEmployee",
                                "la la-bullhorn",
                                "/app/reports/PromotionByEmployee",
                            ),
                            new AppMenuItem(
                                "PromotionBySaleType",
                                "Pages.ReportsFB.PromotionBySaleType",
                                "la la-bullhorn",
                                "/app/reports/PromotionBySaleType",
                            ),
                            new AppMenuItem(
                                "PromotionDetail",
                                "Pages.ReportsFB.Detail",
                                "la la-bullhorn",
                                "/app/reports/PromotionDetail",
                            ),

                            new AppMenuItem(
                                "ComboMealsSales",
                                "Pages.ReportsFB.ComboMealsSales",
                                "la la-object-group",
                                "/app/reports/ComboMealsSales",
                            ),
                            new AppMenuItem(
                                "LoyaltyDiscountReport",
                                "Pages.ReportsFB.LoyaltyDiscount",
                                "la la-heart-o",
                                "/app/reports/loyaltySalesDiscount",
                            ),
                            new AppMenuItem(
                                "TenantsMenuItemSales",
                                "Pages.ReportsFB.TenantsMenuItemsSales",
                                "la la-cutlery",
                                "/app/reports/tenantsMenuItemsReport",
                            ),
                            new AppMenuItem(
                                "TotalSalesByDayReport",
                                "Pages.ReportsFB.TotalSalesByDayReport",
                                "la la-calendar",
                                "/app/reports/totalSalesReportByDayFb",
                            ),
                            new AppMenuItem(
                                "TenantMenuItemSalesSummaryReport",
                                "Pages.ReportsFB.TenantsMenuItemsSalesSummary",
                                "la la-cutlery",
                                "/app/reports/TenantMenuItemSalesSummaryReport",
                            ),

                            // new AppMenuItem(
                            //     "TenantsMenuItemSales",
                            //     "Pages.ReportsFB.TenantsMenuItemsSales",
                            //     "flaticon-cart",
                            //     "/app/reports/tenantsMenuItemsReport"
                            // ),
                        ],
                    ),
                    new AppMenuItem(
                        "TransactionReport",
                        "Pages.FBReports.ReportsTransactionFAB",
                        "la la-list-alt",
                        "",
                        [
                            new AppMenuItem(
                                "Transaction(Types)",
                                "Pages.ReportsFB.Purchase",
                                "la la-list-ol",
                                "/app/reports/purchasereportfb",
                            ),
                            new AppMenuItem(
                                "TotalPurchesSupplierReport",
                                "Pages.ReportsFAB.TotalPurchesByVendorReportFAB",
                                "la la-industry",
                                "/app/reports/TotalPurchesByVendorFABReport",
                            ),
                            new AppMenuItem(
                                "ComparePurchaseReport",
                                "Pages.ReportsFAB.ComparePurchaseFAB",
                                "la la-columns",
                                "/app/reports/ComparePurchaseFABReport",
                            ),
                            new AppMenuItem(
                                "SalesAndPurchaseReport",
                                "Pages.ReportsFB.SalesAndPurchase",
                                "la la-retweet",
                                "/app/reports/salesandpurchasereportfb",
                            ),
                            new AppMenuItem(
                                "StockValuesReport",
                                "Pages.ReportsFB.StockValues",
                                "la la-database",
                                "/app/reports/stockvaluesreportfb",
                            ),
                            new AppMenuItem(
                                "MaterialStockTransaction",
                                "Pages.ReportsFB.MaterialStockTransaction",
                                "la la-exchange",
                                "/app/reports/metrialStockTransactionReportFb",
                            ),
                            new AppMenuItem(
                                "MaterialStockTransactionByPeriod",
                                "Pages.ReportsFB.MaterialStockTransactionByPeriod",
                                "la la-adjust",
                                "/app/reports/MaterialStockTransactionByPeriod",
                            ),
                            new AppMenuItem(
                                "MaterialStockTransactionByPeriodAndEndOfDay",
                                "Pages.ReportsFB.MaterialStockTransactionByPeriodAndEndOfDay",
                                "la la-adjust",
                                "/app/reports/MaterialStockTransactionByPeriodWithBusinessDay",
                            ),
                            new AppMenuItem(
                                "TransferInOut",
                                "Pages.ReportsFB.TransferInOutTransaction",
                                "la la-arrows-h",
                                "/app/reports/TransferInOut",
                            ),
                            new AppMenuItem(
                                "StockValuesWithoutTotals",
                                "Pages.ReportsFAB.StockValuesWithoutTotalsFAB",
                                "la la-database",
                                "/app/reports/StockValuesWithoutTotalsFBAReport",
                            ),
                            new AppMenuItem(
                                "StockValues(Details)",
                                "Pages.ReportsFB.Lot",
                                "la la-database",
                                "/app/reports/lotreportfb",
                            ),
                            new AppMenuItem(
                                "RawMaterial(Order)",
                                "Pages.ReportsFB.OutOfStock",
                                "la la-cart-plus",
                                "/app/reports/outofstockreportfb",
                            ),
                            new AppMenuItem(
                                "RawMaterialsBelowReorder",
                                "Pages.ReportsFAB.RawMaterialsBelowReorder",
                                "la la-battery-quarter",
                                "/app/reports/RawMaterialsBelowReorder",
                            ),
                            new AppMenuItem(
                                "RawMaterial(Unused)",
                                "Pages.ReportsFB.RawMaterialNotUsed",
                                "la la-ban",
                                "/app/reports/rawmaterialnotusedreport",
                            ),
                            new AppMenuItem(
                                "RawMaterial(Trending)",
                                "Pages.ReportsFB.TrendingRawMaterials",
                                "la la-fire",
                                "/app/reports/trendingrawmaterialsreport",
                            ),
                            new AppMenuItem(
                                "RecipeReport",
                                "Pages.ReportsFB.Recipe",
                                "la la-flask",
                                "/app/reports/RecipeReportFb",
                            ),
                            new AppMenuItem(
                                "PurChaseBySupplierReportFB",
                                "Pages.ReportsFB.PurChaseBySupplierReportFB",
                                "la la-industry",
                                "/app/reports/PurChaseBySupplierReportFB",
                            ),
                            new AppMenuItem(
                                "ReturnPurChaseBySupplierReportFB",
                                "Pages.ReportsFB.ReturnPurChaseBySupplierReportFB",
                                "la la-undo",
                                "/app/reports/ReturnPurChaseBySupplierReportFB",
                            ),
                            new AppMenuItem(
                                "RawMaterialRecipyReport",
                                "Pages.ReportsFB.RawMaterialRecipeReport",
                                "la la-flask",
                                "/app/reports/RawMaterialRecipeReportFb",
                            ),
                            new AppMenuItem(
                                "RawMaterialVariant",
                                "Pages.ReportsFB.RawMaterialVariant",
                                "la la-code-fork",
                                "/app/reports/RawMaterialVariant",
                            ),
                            new AppMenuItem(
                                "PurchasingVsSalesQty",
                                "Pages.ReportsFB.PurchasingVsSalesQty",
                                "la la-columns",
                                "/app/reports/PurchasingVsSalesQty",
                            ),
                            new AppMenuItem(
                                "StoreTransferOutReport",
                                "Pages.ReportsFB.StoreTransferOutReport",
                                "la la-arrows-h",
                                "/app/reports/StoreTransferOutReport",
                            ),
                            new AppMenuItem(
                                "StoreOrderReport",
                                "Pages.ReportsFB.StoreOrderReport",
                                "la la-cart-plus",
                                "/app/reports/StoreOrderReport",
                            ),
                            new AppMenuItem(
                                "StoreQuantitiesIssued",
                                "Pages.ReportsFB.StoreQuantitiesIssued",
                                "la la-sign-out",
                                "/app/reports/StoreQuantitiesIssued",
                            ),
                            new AppMenuItem(
                                "StoreReceiveReport",
                                "Pages.ReportsFB.StoreReceiveReport",
                                "la la-sign-in",
                                "/app/reports/StoreReceiveReport",
                            ),
                            new AppMenuItem(
                                "RawWastReport",
                                "Pages.ReportsFB.RawWastReport",
                                "la la-trash-o",
                                "/app/reports/RawWastReport",
                            ),
                            new AppMenuItem(
                                "MenuItemWastReport",
                                "Pages.ReportsFB.MenuItemReport",
                                "la la-trash-o",
                                "/app/reports/MenuItemWastReport",
                            ),
                            new AppMenuItem(
                                "InentoryVarianceWithCostReport",
                                "Pages.ReportsFB.InentoryVarianceWithCost",
                                "la la-adjust",
                                "/app/reports/InentoryVarianceWithCost",
                            ),
                            new AppMenuItem(
                                "MenuItemVariantReport",
                                "Pages.ReportsFB.MenuItem_Variants",
                                "la la-code-fork",
                                "/app/reports/MenuItemsVariantReport",
                            ),
                            new AppMenuItem(
                                "BatchRecipeReport",
                                "Pages.ReportsFB.RawMaterial_Batch_Report",
                                "la la-flask",
                                "/app/reports/batchRecipeReport",
                            ),
                            new AppMenuItem(
                                "PurchaseComparisonPeriods",
                                "Pages.ReportsFB.Compare_Purchase_Report",
                                "la la-columns",
                                "/app/reports/PurchaseComparisonPeriods",
                            ),
                        ],
                    ),
                    new AppMenuItem(
                        "OperationsReport",
                        "Pages.ReportsFB.OperationsReport",
                        "la la-heartbeat",
                        "",
                        [
                            new AppMenuItem(
                                "KDSPerformaceReport",
                                "Pages.ReportsFB.KDSPerformaceReport",
                                "la la-bolt",
                                "/app/reports/KDSPerformaceReport",
                            ),
                            new AppMenuItem(
                                "KDSOrderLifecycleReport",
                                "Pages.ReportsFB.KDSOrderLifecycleReport",
                                "la la-repeat",
                                "/app/reports/KDSOrderLifecycleReport",
                            ),
                            new AppMenuItem(
                                "FastestAndSlowestOrders",
                                "Pages.ReportsFB.FastestAndSlowestOrders",
                                "la la-flag-checkered",
                                "/app/reports/fastestAndSlowestOrders",
                            ),
                            new AppMenuItem(
                                "KDSDeviceHealthReport",
                                "Pages.ReportsFAB.KdsDeviceHealthReport",
                                "la la-stethoscope",
                                "/app/reports/kdsdevicehealthreport",
                            ),
                            new AppMenuItem(
                                "OfflineDevicesReports",
                                "Pages.ReportsFB.Offline_Device_Report",
                                "la la-chain-broken",
                                "/app/operations-reports/offline-devices-report",
                            ),
                            new AppMenuItem(
                                "Kds_Operation_Summary_Report",
                                "Pages.ReportsFB.Kds_Operation_Summary_Reports",
                                "la la-pie-chart",
                                "/app/operations-reports/kds-operation-summary-report",
                            ),
                            new AppMenuItem(
                                "KitchenIntelligenceReport",
                                "Pages.ReportsFB.Kitchen_Intelligence_ItemPerformance_Report",
                                "la la-lightbulb-o",
                                "/app/operations-reports/KitchenIntelligenceReport",
                            ),
                        ],
                    ),
                ],
            ),
            new AppMenuItem(
                "SalesReports",
                "Pages.ReportsSection.sales",
                "la la-line-chart",
                "",
                [
                    new AppMenuItem(
                        "AccountStatementSaleReport",
                        "Pages.Reports.AccountStatementSales",
                        "la la-book",
                        "/app/reports/AccountStatementSaleReport",
                    ),
                    new AppMenuItem(
                        "SalesReport",
                        "Pages.Reports.Sales",
                        "la la-shopping-cart",
                        "/app/reports/salesreport",
                    ),
                    new AppMenuItem(
                        "DailySalesRepor",
                        "Pages.Reports.DailySalesRepor",
                        "la la-calendar",
                        "/app/reports/DailySalesRepor",
                    ),
                    new AppMenuItem(
                        "SalesSummary",
                        "Pages.Reports.SalesSummary",
                        "la la-pie-chart",
                        "/app/reports/SalesSummary",
                    ),
                    new AppMenuItem(
                        "SalesCashiersReport",
                        "Pages.Reports.SalesCashiers",
                        "la la-user",
                        "/app/reports/salescashiersreport",
                    ),
                    new AppMenuItem(
                        "SalesManReport",
                        "Pages.Reports.SalesMan",
                        "la la-suitcase",
                        "/app/reports/total-salesman-report",
                    ),
                    new AppMenuItem(
                        "SalesManDetailsReport",
                        "Pages.Reports.SalesMan",
                        "la la-suitcase",
                        "/app/reports/details-salesman-report",
                    ),
                    new AppMenuItem(
                        "BudgetDeficitReport",
                        "Pages.Reports.BudgetDeficit",
                        "la la-hourglass-half",
                        "/app/reports/budgetdeficitreport",
                    ),
                    new AppMenuItem(
                        "SupplySet",
                        "Pages.Reports.Balance",
                        "la la-money",
                        "/app/reports/balancereport",
                    ),
                    new AppMenuItem(
                        "SalesDetailReport",
                        "Pages.Reports.Sales",
                        "la la-list-ul",
                        "/app/reports/saledetailreport",
                    ),
                    new AppMenuItem(
                        "OfferDetailReport",
                        "Pages.Reports.Sales",
                        "la la-gift",
                        "/app/reports/offerdetailreport",
                    ),
                    new AppMenuItem(
                        "SalesAndPurchaseReportRetialReport",
                        "Pages.Reports.SalesAndPurchase",
                        "la la-retweet",
                        "/app/reports/salesandpurchasereport",
                    ),
                    new AppMenuItem(
                        "ReturnSalesReport",
                        "Pages.Reports.ReturnSales",
                        "la la-undo",
                        "/app/reports/returnsalesreport",
                    ),
                    new AppMenuItem(
                        "compareSalesDayByDayReport",
                        "Pages.Reports.compareSalesDayByDay",
                        "la la-columns",
                        "/app/reports/comparesalesreport",
                    ),
                    new AppMenuItem(
                        "CompareSalesPeriodByPeriodReport",
                        "Pages.Reports.CompareSalesPeriodByPeriod",
                        "la la-columns",
                        "/app/reports/comparesalesperiodbyperiodreport",
                    ),
                    new AppMenuItem(
                        "CompareStocksSalesReport",
                        "Pages.Reports.CompareStocksSales",
                        "la la-columns",
                        "/app/reports/comparestockssalesreport",
                    ),
                    new AppMenuItem(
                        "Sales(TenderTypes)",
                        "Pages.Reports.TenderTypes",
                        "la la-credit-card",
                        "/app/reports/tendertypesreport",
                    ),
                    new AppMenuItem(
                        "TenderTypesReport",
                        "Pages.Reports.TenderTypes",
                        "la la-credit-card",
                        "/app/reports/tender-types-retail-report",
                    ),
                    new AppMenuItem(
                        "TotalSalesByTime",
                        "Pages.Reports.TotalSalesByTime",
                        "la la-clock-o",
                        "/app/reports/total-sales-by-time-retail",
                    ),
                    new AppMenuItem(
                        "SystemSalesReport",
                        "Pages.Reports.SystemSalesReport",
                        "la la-pie-chart",
                        "/app/reports/system-sales-report-retail",
                    ),
                    new AppMenuItem(
                        "IncomeAuditByDay",
                        "Pages.Reports.IncomeAuditByDay",
                        "la la-calendar-check-o",
                        "/app/reports/income-audit-by-day-retail",
                    ),
                    new AppMenuItem(
                        "ProductSalesByTimeReport",
                        "Pages.Reports.ProductSalesByTime",
                        "la la-clock-o",
                        "/app/reports/product-sales-by-time-retail",
                    ),
                    new AppMenuItem(
                        "CustomersSalesReport",
                        "Pages.Reports.CustomersSales",
                        "la la-users",
                        "/app/reports/customerssalesreport",
                    ),
                    new AppMenuItem(
                        "CashFlowReport",
                        "Pages.Reports.CashFlow",
                        "la la-exchange",
                        "/app/reports/cashFlowReport",
                    ),
                    new AppMenuItem(
                        "Sales(Categories)",
                        "Pages.Reports.SalesCategories",
                        "la la-th-large",
                        "/app/reports/productscategoriesalesreport",
                    ),
                    new AppMenuItem(
                        "Sales(Vendors)",
                        "Pages.Reports.SalesVendors",
                        "la la-industry",
                        "/app/reports/TotalSalesSupplierReport",
                    ),
                    new AppMenuItem(
                        "TotalSalesReport",
                        "Pages.Reports.TotalSales",
                        "la la-calculator",
                        "/app/reports/totalsalesreport",
                    ),
                    new AppMenuItem(
                        "SalesMovementReport",
                        "Pages.Reports.SalesMovement",
                        "la la-exchange",
                        "/app/reports/salesmovementreport",
                    ),
                    new AppMenuItem(
                        "Sales(Products)",
                        "Pages.Reports.SalesProducts",
                        "la la-cube",
                        "/app/reports/productsalesreport",
                    ),
                    new AppMenuItem(
                        "Sales(ProductsandVendor)",
                        "Pages.Reports.SalesProductsVendors",
                        "la la-cube",
                        "/app/reports/productVendorsalesreport",
                    ),
                    new AppMenuItem(
                        "CustomersBalanceReport",
                        "Pages.Reports.CustomersBalance",
                        "la la-star-o",
                        "/app/reports/customersbalancereport",
                    ),
                    new AppMenuItem(
                        "ElectronicInvoices",
                        "Pages.Reports.ElectronicInvoices",
                        "la la-file-code-o",
                        "/app/reports/electronicInvoices",
                    ),
                    new AppMenuItem(
                        "EndOfDay",
                        "Pages.Reports.EndOfDay",
                        "la la-moon-o",
                        "/app/reports/endOfDayReport",
                    ),
                    new AppMenuItem(
                        "ZatcaTransactions",
                        "Pages.Reports.ZatcaReport",
                        "la la-institution",
                        "/app/reports/ZatcaTransactions",
                    ),
                ],
            ),

            new AppMenuItem(
                "PurchaseReports",
                "Pages.ReportsSection.Purchases",
                "la la-cart-arrow-down",
                "",
                [
                    new AppMenuItem(
                        "AccountStatementPurchaseReport",
                        "Pages.Reports.AccountStatementPurchases",
                        "la la-book",
                        "/app/reports/AccountStatementPurchaseReport",
                    ),
                    new AppMenuItem(
                        "ProductPurchasesReport",
                        "Pages.Reports.ProductPurchases",
                        "la la-cube",
                        "/app/reports/productpurchasesReport",
                    ),
                    new AppMenuItem(
                        "PurchaseReport",
                        "Pages.Reports.Purchase",
                        "la la-file-text-o",
                        "/app/reports/purchasereport",
                    ),
                    new AppMenuItem(
                        "PurchaseDetailReport",
                        "Pages.Reports.Purchase",
                        "la la-list-ul",
                        "/app/reports/purchasedetailreport",
                    ),
                    new AppMenuItem(
                        "PurchasesComparison",
                        "Pages.Reports.ComparePurchase",
                        "la la-columns",
                        "/app/reports/comparepurchasereport",
                    ),
                    new AppMenuItem(
                        "PurchaseMovementReport",
                        "Pages.Reports.PurchaseMovement",
                        "la la-exchange",
                        "/app/reports/purchasemovementreport",
                    ),
                    new AppMenuItem(
                        "Purchases(Vendors)",
                        "Pages.Reports.PurchasesVendors",
                        "la la-industry",
                        "/app/reports/TotalPurchesSupplierReport",
                    ),
                ],
            ),
            new AppMenuItem(
                "InventoryReports",
                "Pages.Inventory.InventoryReport",
                "la la-archive",
                "",
                [
                    new AppMenuItem(
                        "StockValuesReport",
                        "Pages.Reports.StockValues",
                        "la la-database",
                        "/app/reports/stockvaluesreport",
                    ),
                    new AppMenuItem(
                        "OutOfStockReport",
                        "Pages.Reports.OutOfStock",
                        "la la-battery-empty",
                        "/app/reports/outofstockreport",
                    ),
                    new AppMenuItem(
                        "OutOfStockDetailReport",
                        "Pages.Reports.OutOfStockDetail",
                        "la la-battery-empty",
                        "/app/reports/outofstockdetailreport",
                    ),
                    new AppMenuItem(
                        "LotReport",
                        "Pages.Reports.Lot",
                        "la la-sort-numeric-asc",
                        "/app/reports/lotreport",
                    ),
                    new AppMenuItem(
                        "ProductCardReport",
                        "Pages.Reports.ProductCard",
                        "la la-file-text-o",
                        "/app/reports/productcardreport",
                    ),
                    new AppMenuItem(
                        "TransfersReport",
                        "Pages.Reports.Transfers",
                        "la la-arrows-h",
                        "/app/reports/transfersreport",
                    ),
                    new AppMenuItem(
                        "ProductNotUsed",
                        "Pages.Reports.ProductNotUsed",
                        "la la-ban",
                        "/app/reports/productnotusedreport",
                    ),
                    new AppMenuItem(
                        "ProductMovementReport",
                        "Pages.Reports.ProductMovement",
                        "la la-exchange",
                        "/app/reports/productMovementReport",
                    ),
                    new AppMenuItem(
                        "ProductBasicReport",
                        "Pages.Reports.ProductBasic",
                        "la la-cube",
                        "/app/reports/ProductBasicReport",
                    ),
                    new AppMenuItem(
                        "StockValuesWithoutTotals",
                        "Pages.Reports.StockValuesWithoutTotals",
                        "la la-database",
                        "/app/reports/stockvalueswithouttotalsreport",
                    ),
                    new AppMenuItem(
                        "TrendingProductsReport",
                        "Pages.Reports.TrendingProducts",
                        "la la-fire",
                        "/app/reports/trendingproductsreport",
                    ),
                ],
            ),

            new AppMenuItem(
                "EcoSystems",
                "Pages.EcoSystems",
                "la la-share-alt",
                "",
                [
                    new AppMenuItem(
                        "CallCenter",
                        "Pages.EcoSystems.CallCenter",
                        "la la-headphones",
                        "/app/ecoSystems/callCenter",
                    ),
                    new AppMenuItem(
                        "kiosk",
                        "Pages.EcoSystems.Kiosk",
                        "la la-hand-pointer-o",
                        "/app/ecoSystems/kiosk",
                    ),
                     new AppMenuItem(
                        "OnlineOrdering",
                        "Pages.EcoSystems.OrderLine",
                        "la la-mouse-pointer",
                        "/app/ecoSystems/onlineOrder",
                    ),
                ],
            ),

            new AppMenuItem(
                "BackOffice",
                "Pages.BackOffice",
                "la la-briefcase",
                "",
                [
                    new AppMenuItem(
                        "Currencies",
                        "Pages.BackOffice.Currencies",
                        "la la-globe",
                        "/app/backoffice/currencies",
                    ),
                    new AppMenuItem(
                        "WorkingHours",
                        "Pages.BackOffice.WorkingHours",
                        "la la-clock-o",
                        "/app/backoffice/workinghours",
                    ),
                    new AppMenuItem(
                        "STOREType",
                        "Pages.BackOffice.StoreGroup",
                        "la la-sitemap",
                        "/app/backoffice/StoreTypes",
                    ),
                    new AppMenuItem(
                        "Stores",
                        "Pages.BackOffice.Stores",
                        "la la-building-o",
                        "/app/backoffice/stores",
                    ),
                    new AppMenuItem(
                        "TenderTypes",
                        "Pages.BackOffice.TenderTypesFB",
                        "la la-credit-card",
                        "/app/backoffice/tendertypes",
                    ),
                    new AppMenuItem(
                        "TenderTypeMasters",
                        "Pages.BackOffice.TenderTypeMaster",
                        "la la-credit-card",
                        "/app/backoffice/tendertypemasters",
                    ),
                    new AppMenuItem(
                        "Taxes",
                        "Pages.BackOffice.Taxes",
                        "la la-legal",
                        "/app/backoffice/taxes",
                    ),
                    new AppMenuItem(
                        "UnitsOfMeasure",
                        "Pages.BackOffice.UnitsOfMeasure",
                        "la la-arrows-v",
                        "/app/backoffice/unitsofmeasure",
                    ),
                    new AppMenuItem(
                        "VariantsFB",
                        "Pages.BackOffice.VariantsFB",
                        "la la-code-fork",
                        "/app/backoffice/variantsFB",
                    ),
                    new AppMenuItem(
                        "ModifiersGroupAndOptions",
                        "Pages.BackOffice.ModifiersGroupAndOptions",
                        "la la-plus-square-o",
                        "/app/backoffice/ModifiersGroupAndOptions",
                    ),
                    new AppMenuItem(
                        "Clubs",
                        "Pages.BackOffice.Clubs",
                        "la la-trophy",
                        "/app/backoffice/clubs",
                    ),
                    new AppMenuItem(
                        "Schemas",
                        "Pages.BackOffice.Schemas",
                        "la la-star-half-o",
                        "/app/backoffice/schemas",
                    ),
                    new AppMenuItem(
                        "Accounts",
                        "Pages.BackOffice.Accounts",
                        "la la-book",
                        "/app/backoffice/accounts",
                    ),
                    new AppMenuItem(
                        "CodingPatternSettings",
                        "Pages.BackOffice.CodingPatternSettings",
                        "la la-code",
                        "/app/backoffice/codingpatternsettings",
                    ),
                    new AppMenuItem(
                        "PrimaryCategories",
                        "Pages.BackOffice.PrimaryCategories",
                        "la la-th-large",
                        "/app/backoffice/primarycategories",
                    ),
                    new AppMenuItem(
                        "SecondaryCategories",
                        "Pages.BackOffice.SecondaryCategories",
                        "la la-th",
                        "/app/backoffice/secondarycategories",
                    ),
                    new AppMenuItem(
                        "ProductCategories",
                        "Pages.BackOffice.ProductCategories",
                        "la la-th-list",
                        "/app/backoffice/productcategories",
                    ),
                    new AppMenuItem(
                        "Variants",
                        "Pages.BackOffice.Variants",
                        "la la-code-fork",
                        "/app/backoffice/variants",
                    ),
                    new AppMenuItem(
                        "Vendors",
                        "Pages.BackOffice.Vendors",
                        "la la-industry",
                        "/app/backoffice/vendors",
                    ),
                    new AppMenuItem(
                        "Attributes",
                        "Pages.BackOffice.Attributes",
                        "la la-tags",
                        "/app/backoffice/attributes",
                    ),
                    new AppMenuItem(
                        "Products",
                        "Pages.BackOffice.Products",
                        "la la-cube",
                        "/app/backoffice/products",
                    ),
                    new AppMenuItem(
                        "Groups",
                        "Pages.BackOffice.Groups",
                        "la la-folder-open-o",
                        "/app/backoffice/groups",
                    ),
                    new AppMenuItem(
                        "PurchaseInvoices",
                        "Pages.BackOffice.PurchaseInvoices",
                        "la la-file-text-o",
                        "/app/backoffice/purchaseinvoices",
                    ),
                    new AppMenuItem(
                        "PurchaseInvoiceOrders",
                        "Pages.BackOffice.PurchaseInvoiceOrders",
                        "la la-cart-plus",
                        "/app/backoffice/purchaseInvoiceOrders",
                    ),
                    new AppMenuItem(
                        "ApprovalWorkflows",
                        "Pages.BackOffice.ApprovalWorkflows",
                        "la la-check-circle-o",
                        "/app/backoffice/approvalWorkflows",
                    ),
                    new AppMenuItem(
                        "PurchaseInvoicesReturns",
                        "Pages.BackOffice.PurchaseInvoicesReturns",
                        "la la-undo",
                        "/app/backoffice/purchaseinvoicesReturns",
                    ),
                    new AppMenuItem(
                        "SalesTransactions",
                        "Pages.BackOffice.SaleTransactions",
                        "la la-shopping-cart",
                        "/app/backoffice/saletransactions",
                    ),
                    new AppMenuItem(
                        "InventoryReceiveRetail",
                        "Pages.BackOffice.InventoryReceiveRetail",
                        "la la-sign-in",
                        "/app/backoffice/inventoryReceiveRetail",
                    ),
                    new AppMenuItem(
                        "InventoryOrderRetail",
                        "Pages.BackOffice.InventoryOrdersRetail",
                        "la la-cart-plus",
                        "/app/backoffice/inventoryOrderRetail",
                    ),
                    new AppMenuItem(
                        "Terminals",
                        "Pages.BackOffice.Terminals",
                        "la la-keyboard-o",
                        "/app/backoffice/terminals",
                    ),
                    new AppMenuItem(
                        "Offers",
                        "Pages.BackOffice.Offers",
                        "la la-gift",
                        "/app/backoffice/offers",
                    ),
                    new AppMenuItem(
                        "PromotionsOffer",
                        "Pages.BackOffice.Promotions",
                        "la la-bullhorn",
                        "/app/backoffice/promotions",
                    ),
                    new AppMenuItem(
                        "PromotionsOffer",
                        "Pages.BackOffice.PromotionFBs",
                        "la la-bullhorn",
                        "/app/backoffice/promotionsfb",
                    ),
                    new AppMenuItem(
                        "PromotionsCodeOffer",
                        "Pages.BackOffice.PromotionsCode",
                        "la la-ticket",
                        "/app/backoffice/promotionsCode",
                    ),
                    new AppMenuItem(
                        "PromotionsCodeOffer",
                        "Pages.BackOffice.PromotionCodeFBs",
                        "la la-ticket",
                        "/app/backoffice/promotionCodeFB",
                    ),
                    new AppMenuItem(
                        "Scale",
                        "Pages.BackOffice.Scale",
                        "la la-balance-scale",
                        "/app/backoffice/scaleconfigs",
                    ),
                    new AppMenuItem(
                        "DiscountTypes",
                        "Pages.BackOffice.DiscountTypesRetail",
                        "la la-tag",
                        "/app/backoffice/discounttypesretail",
                    ),
                    new AppMenuItem(
                        "Points",
                        "Pages.BackOffice.Points",
                        "la la-star-o",
                        "/app/backoffice/points",
                    ),
                    new AppMenuItem(
                        "CountedStocks",
                        "Pages.BackOffice.Products",
                        "la la-check-square-o",
                        "/app/backoffice/countedStocksRetial",
                    ),
                    new AppMenuItem(
                        "StockOpeningAdjustment",
                        "Pages.BackOffice.StockOpeningAdjustmentRetail",
                        "la la-flag-o",
                        "/app/backoffice/stockopeningadjustmentretail",
                    ),
                    new AppMenuItem(
                        "HappyHour",
                        "Pages.BackOffice.HappyHourFB",
                        "la la-glass",
                        "/app/backoffice/happyhour",
                    ),
                    new AppMenuItem(
                        "ExportProductBarcode",
                        "Pages.BackOffice.ExportProductBarcode",
                        "la la-barcode",
                        "/app/backoffice/printbarcode",
                    ),
                    new AppMenuItem(
                        "Areas",
                        "Pages.BackOffice.Areas",
                        "la la-map-o",
                        "/app/backoffice/areas",
                    ),
                    new AppMenuItem(
                        "Region",
                        "Pages.BackOffice.Region",
                        "la la-map",
                        "/app/backoffice/region",
                    ),
                    new AppMenuItem(
                        "EndOfDayManage",
                        "Pages.BackOffice.EndOfDay",
                        "la la-moon-o",
                        "/app/backoffice/EndOfDayManage",
                    ),
                ],
            ),

            new AppMenuItem(
                "FrontOffice",
                "Pages.FrontOffice",
                "la la-desktop",
                "",
                [
                    new AppMenuItem(
                        "Customers",
                        "Pages.FrontOffice.Customers",
                        "la la-users",
                        "/app/frontoffice/customers",
                    ),
                    new AppMenuItem(
                        "Shifts",
                        "Pages.FrontOffice.Shifts",
                        "la la-hourglass-half",
                        "/app/frontoffice/shifts",
                    ),
                ],
            ),
            new AppMenuItem("Sales", "", "la la-shopping-cart", "", [
                new AppMenuItem(
                    "Categories",
                    "Pages.BackOffice.Categories",
                    "la la-th-large",
                    "/app/backoffice/productgroup",
                ),
                new AppMenuItem(
                    "Levels",
                    "Pages.BackOffice.Level",
                    "la la-signal",
                    "/app/backoffice/levels",
                ),
                new AppMenuItem(
                    "MenuItem",
                    "Pages.BackOffice.MenuItem",
                    "la la-cutlery",
                    "/app/backoffice/menuitem",
                ),
                new AppMenuItem(
                    "ComboMeals",
                    "Pages.Sales.ComboMealsPackages",
                    "la la-object-group",
                    "/app/backoffice/ComboMealsPackages",
                ),
                new AppMenuItem(
                    "ComboMealsDefinitions",
                    "Pages.Sales.ComboMealsDefinitions",
                    "la la-object-ungroup",
                    "/app/backoffice/ComboMealsDefinition",
                ),
                new AppMenuItem(
                    "StoreMenuItemConfig",
                    "Pages.BackOffice.StoreMenuItemConfig",
                    "la la-building-o",
                    "/app/backoffice/storemenuitemconfig",
                ),
                new AppMenuItem(
                    "ReportGroup",
                    "Pages.BackOffice.ReportGroup",
                    "la la-folder-o",
                    "/app/backoffice/reportGroups",
                ),
                new AppMenuItem(
                    "ComboGroups",
                    "Pages.BackOffice.ComboGroups",
                    "la la-clone",
                    "/app/backoffice/combogroups",
                ),
                new AppMenuItem(
                    "ServiceCharge",
                    "Pages.BackOffice.ServiceCharge",
                    "la la-plus-circle",
                    "/app/backoffice/servicecharge",
                ),
                new AppMenuItem(
                    "DiscountTypes",
                    "Pages.BackOffice.DiscountTypes",
                    "la la-tag",
                    "/app/backoffice/discounttypes",
                ),
                new AppMenuItem(
                    "RefundReson",
                    "Pages.Sales.RefundReson",
                    "la la-commenting-o",
                    "/app/backoffice/RefundReson",
                ),
            ]),
            new AppMenuItem("SystemProperties", "", "la la-sliders", "", [
                new AppMenuItem(
                    "PriceList",
                    "Pages.BackOffice.PriceList",
                    "la la-usd",
                    "/app/backoffice/pricelist",
                ),
                new AppMenuItem(
                    "SaleType",
                    "Pages.BackOffice.SaleType",
                    "la la-random",
                    "/app/backoffice/saletype",
                ),
                new AppMenuItem(
                    "Corners",
                    "Pages.BackOffice.Corners",
                    "la la-map-signs",
                    "/app/backoffice/corners",
                ),
                new AppMenuItem(
                    "Tables",
                    "Pages.BackOffice.Tables",
                    "la la-table",
                    "/app/backoffice/tables",
                ),
                new AppMenuItem(
                    "DeviceManagment",
                    "Pages.BackOffice.Device.Managment",
                    "la la-tablet",
                    "/app/backoffice/DevicesManagment",
                ),
            ]),
            new AppMenuItem("Delivery", "", "la la-motorcycle", "", [
                new AppMenuItem(
                    "DeliveryManagement",
                    "Pages.BackOffice.DeliveryManagement",
                    "la la-truck",
                    "/app/backoffice/deliveryManagement",
                ),
                new AppMenuItem(
                    "DeliveryZone",
                    "Pages.BackOffice.DeliveryZone",
                    "la la-map-marker",
                    "/app/backoffice/deliveryZone",
                ),
                new AppMenuItem(
                    "DeliveryStreet",
                    "Pages.BackOffice.DeliveryStreet",
                    "la la-road",
                    "/app/backoffice/deliveryStreet",
                ),
                new AppMenuItem(
                    "DeliveryCustomer",
                    "Pages.BackOffice.DeliveryCustomer",
                    "la la-users",
                    "/app/frontoffice/deliverycustomers",
                ),
            ]),
            new AppMenuItem(
                "Inventory",
                "Pages.Inventory",
                "la la-cubes",
                "",
                [
                    new AppMenuItem(
                        "Config",
                        "Pages.Inventory.Config",
                        "la la-sliders",
                        "",
                        [
                            new AppMenuItem(
                                "Supplier",
                                "Pages.BackOffice.Suppliers",
                                "la la-industry",
                                "/app/backoffice/suppliers",
                            ),
                            new AppMenuItem(
                                "MainGroup",
                                "Pages.BackOffice.MainGroup",
                                "la la-th-large",
                                "/app/backoffice/maingroup",
                            ),
                            new AppMenuItem(
                                "MaterialGroup",
                                "Pages.BackOffice.MaterialGroup",
                                "la la-th",
                                "/app/backoffice/materialgroup",
                            ),
                            new AppMenuItem(
                                "Period",
                                "Pages.BackOffice.Period",
                                "la la-calendar-o",
                                "/app/backoffice/period",
                            ),
                            new AppMenuItem(
                                "RawMaterial",
                                "Pages.BackOffice.RawMaterial",
                                "la la-leaf",
                                "/app/backoffice/rawmaterial",
                            ),
                            new AppMenuItem(
                                "StoreRawMaterialConfig",
                                "Pages.BackOffice.StoreRawMaterialConfig",
                                "la la-building-o",
                                "/app/backoffice/rawMaterialConfig",
                            ),
                            new AppMenuItem(
                                "Recipes",
                                "Pages.BackOffice.Recipe",
                                "la la-flask",
                                "/app/backoffice/recipe",
                            ),
                        ],
                    ),
                    // Inventory => InventoryTransaction
                    new AppMenuItem(
                        "InventoryTransaction",
                        "Pages.Inventory.InventoryTransaction",
                        "la la-exchange",
                        "",
                        [
                            new AppMenuItem(
                                "StockOpeningAdjustment",
                                "Pages.Inventory.InventoryTransaction.StockOpeningAdjustment",
                                "la la-flag-o",
                                "/app/backoffice/stockopeningadjustment",
                            ),
                            new AppMenuItem(
                                "InventoryReceive",
                                "Pages.Inventory.InventoryTransaction.InventoryReceive",
                                "la la-sign-in",
                                "/app/backoffice/inventoryreceive",
                            ),
                            new AppMenuItem(
                                "InventoryOrder",
                                "Pages.Inventory.InventoryTransaction.InventoryOrder",
                                "la la-cart-plus",
                                "/app/backoffice/inventoryorder",
                            ),
                            new AppMenuItem(
                                "InvoicePurshase",
                                "Pages.Inventory.InventoryTransaction.PurshaseInvoice",
                                "la la-file-text-o",
                                "/app/backoffice/inventoryPurshaseInvoice",
                            ),
                            new AppMenuItem(
                                "ReturnInvoicePurshase",
                                "Pages.Inventory.InventoryTransaction.ReurnPurshaseInvoice",
                                "la la-undo",
                                "/app/backoffice/inventoryPurshaseRerturnInvoice",
                            ),
                            new AppMenuItem(
                                "InventoryTransfers",
                                "Pages.Inventory.InventoryTransaction.InventoryTransfers",
                                "la la-arrows-h",
                                "/app/backoffice/inventoryTransfer",
                            ),
                            new AppMenuItem(
                                "InventoryRawWaste",
                                "Pages.Inventory.InventoryTransaction.InventoryRawWaste",
                                "la la-trash-o",
                                "/app/backoffice/inventoryrawwaste",
                            ),
                            new AppMenuItem(
                                "MenuItemWaste",
                                "Pages.Inventory.InventoryTransaction.MenuItemWaste",
                                "la la-trash-o",
                                "/app/backoffice/menuitemwaste",
                            ),
                            new AppMenuItem(
                                "stockAdjustments",
                                "Pages.BackOffice.StockAdjustment",
                                "la la-pencil-square-o",
                                "/app/backoffice/stockAdjustment",
                            ),
                            new AppMenuItem(
                                "BatchRecipe",
                                "Pages.BackOffice.BatchRecipe",
                                "la la-flask",
                                "/app/backoffice/batchRecipe",
                            ),
                            new AppMenuItem(
                                "CountedStocks",
                                "Pages.Inventory.InventoryTransaction.CountedStock",
                                "la la-check-square-o",
                                "/app/backoffice/countedStock",
                            ),
                            new AppMenuItem(
                                "TransactionTemplate",
                                "Pages.Inventory.InventoryTransaction.TransactionTemplate",
                                "la la-clipboard",
                                "/app/backoffice/transactiontemplate",
                            ),
                        ],
                    ),
                    new AppMenuItem(
                        "InventoryManagment",
                        "Pages.Inventory.InventoryManagment",
                        "la la-tasks",
                        "",
                        [
                            new AppMenuItem(
                                "MainTransactionSettings",
                                "Pages.BackOffice.MainTransactionSettings",
                                "la la-toggle-on",
                                "/app/backoffice/transactionSettings",
                            ),
                            new AppMenuItem(
                                "TransactionType",
                                "Pages.BackOffice.TransactionType",
                                "la la-list-ol",
                                "/app/admin/transactionTypesettings",
                            ),
                            new AppMenuItem(
                                "MainTransactionRevision",
                                "Pages.BackOffice.InventoryMainTransactionRevision",
                                "la la-thumbs-o-up",
                                "/app/backoffice/transactionRevision",
                            ),
                            new AppMenuItem(
                                "InventoryReciveRevision",
                                "Pages.BackOffice.InventoryReceiveRevision",
                                "la la-check-circle-o",
                                "/app/backoffice/inventoryreceiverevision",
                            ),
                            new AppMenuItem(
                                "ViewStockOnHand",
                                "Pages.BackOffice.StockCount",
                                "la la-eye",
                                "/app/backoffice/stockcount",
                            ),
                            new AppMenuItem(
                                "StockPeriod",
                                "Pages.BackOffice.StockPeriod",
                                "la la-calendar-o",
                                "/app/backoffice/stockperiod",
                            ),
                        ],
                    ),
                ],
            ),
            new AppMenuItem("Devices", "", "la la-plug", "", [
                new AppMenuItem(
                    "PC",
                    "Pages.BackOffice.PC",
                    "la la-laptop",
                    "/app/backoffice/pcs",
                ),
                new AppMenuItem(
                    "Devices",
                    "Pages.BackOffice.Device",
                    "la la-tablet",
                    "/app/backoffice/devices",
                ),
            ]),
            new AppMenuItem(
                "Market Place",
                "Pages.MarketPlace",
                "la la-puzzle-piece",
                "",
                [
                    new AppMenuItem(
                        "Ms365",
                        "Pages.MarketPlace.Ms365",
                        "la la-cloud-upload",
                        "/app/MarketPlace/Ms365",
                    ),
                    new AppMenuItem(
                        "Business Central",
                        "Pages.MarketPlace.BusinessCentral",
                        "la la-cloud",
                        "/app/MarketPlace/BusinessCentral",
                    ),
                    new AppMenuItem(
                        "ErpIntegration",
                        "Pages.MarketPlace.BusinessCentral.ErpIntegration",
                        "la la-link",
                        "/app/MarketPlace/ErpIntegration",
                    ),
                ],
            ),

            new AppMenuItem("Administration", "", "la la-shield", "", [
                new AppMenuItem(
                    "PosConfigurationsReport",
                    "Pages.Administration.PosConfigurations",
                    "la la-cogs",
                    "/app/reports/posconfigurationsreport",
                ),
                new AppMenuItem(
                    "ChildrenTenants",
                    "Pages.ChildrenTenantsManagement",
                    "la la-level-down",
                    "/app/admin/childrenTenants",
                ),
                new AppMenuItem(
                    "UsersLog",
                    "Pages.Tenant.UsersLog",
                    "la la-history",
                    "/app/admin/userLogs",
                ),
                new AppMenuItem(
                    "PluginSyncLog",
                    "Pages.Tenant.PluginSyncLog",
                    "la la-refresh",
                    "/app/admin/PluginSyncLog",
                ),
                new AppMenuItem(
                    "Roles",
                    "Pages.Administration.Roles",
                    "la la-key",
                    "/app/admin/roles",
                ),
                new AppMenuItem(
                    "Users",
                    "Pages.Administration.Users",
                    "la la-user",
                    "/app/admin/users",
                ),
                new AppMenuItem(
                    "Languages",
                    "Pages.Administration.Languages",
                    "la la-language",
                    "/app/admin/languages",
                ),
                new AppMenuItem(
                    "AuditLogs",
                    "Pages.Administration.AuditLogs",
                    "la la-search",
                    "/app/admin/auditLogs",
                ),
                new AppMenuItem(
                    "Maintenance",
                    "Pages.Administration.Host.Maintenance",
                    "la la-wrench",
                    "/app/admin/maintenance",
                ),
                new AppMenuItem(
                    "Subscription",
                    "Pages.Administration.Tenant.SubscriptionManagement",
                    "la la-certificate",
                    "/app/admin/subscription-management",
                ),
                new AppMenuItem(
                    "VisualSettings",
                    "Pages.Administration.UiCustomization",
                    "la la-paint-brush",
                    "/app/admin/ui-customization",
                ),
                new AppMenuItem(
                    "Host Settings",
                    "Pages.Administration.Host.Settings",
                    "la la-cog",
                    "/app/admin/hostSettings",
                ),
                new AppMenuItem(
                    "LoyaltyQrKeys",
                    "Pages.Administration.LoyaltyQrKeys",
                    "la la-qrcode",
                    "/app/admin/loyaltyQrKeys",
                    [],
                    true,
                ),
                new AppMenuItem(
                    "Settings",
                    "Pages.Administration.Tenant.Settings",
                    "la la-cog",
                    "/app/admin/tenantSettings",
                ),
                new AppMenuItem(
                    "ExportData",
                    "Pages.Administration.Tenant.ExportData",
                    "la la-download",
                    "/app/admin/exportdata",
                ),
            ]),
            new AppMenuItem(
                "Tenants",
                "Pages.Tenants",
                "la la-building",
                "/app/admin/tenants",
            ),
            new AppMenuItem(
                "Clusters",
                "Pages.Clusters",
                "la la-server",
                "/app/admin/cluster",
            ),
            new AppMenuItem(
                "Editions",
                "Pages.Editions",
                "la la-diamond",
                "/app/admin/editions",
            ),
            new AppMenuItem(
                "MobileAppUI",
                "Pages.MobileAppUI",
                "la la-mobile",
                "/app/admin/mobileAppUI",
            ),
            new AppMenuItem(
                "SecondDisplayUI",
                "Pages.SecondDisplayUI",
                "la la-television",
                "/app/admin/secondDisplayUI",
            ),
            new AppMenuItem(
                "TabletAppUI",
                "Pages.TabletAppUI",
                "la la-tablet",
                "/app/admin/tabletAppUI",
            ),
            new AppMenuItem(
                "KioskUI",
                "Pages.Kiosk",
                "la la-hand-pointer-o",
                "/app/admin/KioskUI",
            ),
            new AppMenuItem(
                "QRMenaAppUI",
                "Pages.QRMena",
                "la la-qrcode",
                "/app/admin/QRMenaAppUI",
            ),
            new AppMenuItem(
                "ReceiptCustomizationUI",
                "Pages.ReceiptCustomizationUI",
                "la la-print",
                "/app/admin/ReceiptCustomizationUI",
            ),

            new AppMenuItem(
                "DemoUiComponents",
                "Pages.DemoUiComponents",
                "la la-magic",
                "/app/admin/demo-ui-components",
            ),
            new AppMenuItem(
                "Devices",
                "Pages.Tenant.Devices",
                "la la-plug",
                "/app/admin/devices",
            ),
        ]);
    }

    checkChildMenuItemPermission(menuItem): boolean {
        for (let i = 0; i < menuItem.items.length; i++) {
            let subMenuItem = menuItem.items[i];

            if (
                subMenuItem.permissionName &&
                this._permissionService.isGranted(subMenuItem.permissionName)
            ) {
                return true;
            }

            if (subMenuItem.items && subMenuItem.items.length) {
                return this.checkChildMenuItemPermission(subMenuItem);
            } else if (!subMenuItem.permissionName) {
                return true;
            }
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/nav/app-navigation.service.ts